import Loadable from "react-loadable";

export const FundraisingStatus = Loadable({
  loader: () => import("../../../../modules/manage-pitch").then((module) => module.FundraisingStatus) as Promise<any>,
  loading: () => null,
});
